import { icons } from '@ublend-npm/aulaui-next';
import React, { KeyboardEvent } from 'react';
import { Transforms } from 'slate';
import {
  ReactEditor,
  useSlateStatic,
  useSelected,
  useReadOnly,
} from 'slate-react';
import { UnsupportedElement } from '../../plugins/unsupported/UnsupportedElement';
import {
  Container,
  Title,
  Description,
  DescriptionWrapper,
} from './Unsupported.styled';

export type UnsupportedProps = {
  element: UnsupportedElement;
};

export const Unsupported = ({ element }: UnsupportedProps) => {
  const editor = useSlateStatic();
  const isReadOnly = useReadOnly();
  const isSelected = useSelected();
  const at = ReactEditor.findPath(editor, element);

  const handleDeleteBlock = () => Transforms.removeNodes(editor, { at });

  const variant = element.variant || 'block';

  return (
    <Container isSelected={isSelected} data-testid={`unsupported-${variant}`}>
      {variant === 'image' ? (
        <>
          <icons.Image fontSize="large" />
          <DescriptionWrapper>
            <Title>Image placeholder</Title>
            {!isReadOnly && (
              <Description>
                Images must be pasted into Aula separately from the text. This
                placeholder indicates where an image was in the original
                content—you can remove it after pasting the image.
              </Description>
            )}
          </DescriptionWrapper>
        </>
      ) : (
        <>
          <icons.WarningIcon fontSize="large" />
          <DescriptionWrapper>
            <Title>Unsupported block type</Title>
            <Description>
              It looks like we don’t support this type of content.
            </Description>
          </DescriptionWrapper>
        </>
      )}
      {!isReadOnly && (
        <icons.Close
          title="close"
          tabIndex="0"
          role="button"
          onClick={handleDeleteBlock}
          onKeyDown={(e: KeyboardEvent) =>
            e.key === 'Enter' && handleDeleteBlock
          }
          style={{
            fontSize: '20px',
            color: 'black',
            cursor: 'pointer',
            marginLeft: 'auto',
          }}
        />
      )}
    </Container>
  );
};
